module.exports = __webpack_public_path__ + "public-ui/img/chevron-down.bfa8f0c6.svg";